<app-common-announcement [announcementMessage]="announcementData"></app-common-announcement>

@if (this.access_token == '') {
@if(isSchoolLoginDesign) {
<div class="container for_school_user">
  <div class="row  align-items-center login-font flex-res r-form">
    <div class="card">
      <div class="row align-items-center">
        <div class="col-md-12 col-lg-6 p-0 rounded-0 border-0 login_background_image">
          <div class="d-flex position-relative">
            <img alt="" class="img-fluid w-100" src="../../../../assets/images/favicon/Group 1000001671.png" />
            <div class="position-absolute w-100 card-text-white">
              <div class="card-body login-content">
                <p class="join_hub">
                  <span class="hub">The ultimate hub</span> for jobs and bookings in
                  education
                </p>
                <div class="d-flex mt-20">
                  <p class="txt-regular fs-16 class-txt">New to ClassCover?</p>
                  <a class="text-regular-medium fs-16  u_l  class-txt  ml-5"
                    href="https://www.classcover.com.au/lets-make-sure-you-are-in-the-right-place/">
                    <b>Get started</b>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="">
            <div class="register-form">
              <div class="px-0 pt-5 mb-4">
                <p class="text-center">
                  <img alt="" class="r_image" src="assets/images/favicon/CClogoFINAL-02 1.png" />
                </p>
                <p class="mt-50 txt-regular fs-18" *ngIf="!showOtpInput&& !emailVerified">Login to ClassCover</p>

                <div class="col-lg-12 mt-20">
                  <div class="">
                    <form [formGroup]="loginForm" novalidate>
                      @if(!showOtpInput && !emailVerified) {
                      <div class="col-lg-12 mt-15">
                        <label for="username" id="username_label">Email</label>
                        <input type="text" id="username" autocomplete="username" aria-labelledby="username_label"
                          ariaLabel="enter user name" id="username" class="form-control input-sm  chat-input"
                          formControlName="username" placeholder="Type email" />
                      </div>
                      <div class="col-lg-12 mt-15">
                        <label for="userPassword" id="password_label">Password</label>

                        <div class="input-group">
                          <input [type]="showPassword ? 'text' : 'password'" id="userPassword"
                            aria-labelledby="password_label" autocomplete="current-password"
                            class="form-control input-sm chat-input showPassRadius" formControlName="password"
                            placeholder="Type password" />

                          <button type="button" class="input-group-text" (click)="togglePassword()"
                            style="cursor: pointer;">
                            <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                          </button>
                        </div>
                      </div>
                      <div class="col-lg-12 mt-5">
                        @if (mandatoryMessage) {
                        <div class="warningMessage fs-14 txt-regular  text-danger mt-2">
                          <p aria-label="Please Enter User Name and Password">
                            Please enter user name and password.
                          </p>
                        </div>
                        } @if (validationMessage) {
                        <div class="warningMessage fs-14  txt-regular text-danger mt-2">
                          <p aria-label="Invalid User Name or Password">
                            {{ error_log }}
                          </p>
                        </div>
                        }
                      </div>
                      <div class="mt-15 d-flex">
                        <div class="flex-grow-1">
                          <input type="checkbox" id="rememberMe" class="form-check-input"
                            formControlName="rememberMe" />
                          <label for="rememberMe" class="txt-regular ml-5 mt-4 c-p">Remember me</label>
                        </div>
                        <div>
                          <a href="/forgot-password" role="button" aria-label="Forget Password?"
                            class="text-regular-medium align-right clr-cc-vilot c-p" appFocus appClick>
                            Forgot Password</a>
                        </div>
                      </div>

                      <div class="mt-25">
                        <button type="submit" (click)="logIn()" aria-label="Login" class="btn w-100 cc_p_btn fs_13">
                          Login
                        </button>
                      </div>
                      }

                      @if(showOtpInput) {
                      <div *ngIf="showOtpInput" class="mt-10">
                        <p class="mt-30 txt-regular fs-16">Check your email for a code</p>
                        <p class="mt-16 txt-regular fs-14">We've sent a 6-digit code to {{userEmail}}. This code expires
                          in {{expiryTime}} minutes.</p>
                        <div class="mt-16">
                          <form [formGroup]="mfaForm" novalidate>
                            <div class="d-flex justify-content-between gap-2 flex-wrap">
                              <input id="otp-input-0" maxlength="1" [ngModelOptions]="{standalone: true}" type="text"
                                pattern="[0-9]*" inputmode="numeric" class="otp-box" [(ngModel)]="otp[0]"
                                (keyup)="onDigitInput($event, 0)" (input)="onOtpChange(0, $event)"
                                (paste)="$event.preventDefault()" autocomplete="one-time-code" #digit0 />
                              <input id="otp-input-1" maxlength="1" [ngModelOptions]="{standalone: true}" type="text"
                                pattern="[0-9]*" inputmode="numeric" class="otp-box" [(ngModel)]="otp[1]"
                                (keyup)="onDigitInput($event, 1)" (input)="onOtpChange(1, $event)"
                                (paste)="$event.preventDefault()" autocomplete="one-time-code" #digit1 />
                              <input id="otp-input-2" maxlength="1" [ngModelOptions]="{standalone: true}" type="text"
                                pattern="[0-9]*" inputmode="numeric" class="otp-box" [(ngModel)]="otp[2]"
                                (keyup)="onDigitInput($event, 2)" (input)="onOtpChange(2, $event)"
                                (paste)="$event.preventDefault()" autocomplete="one-time-code" #digit2 />
                              <input id="otp-input-3" maxlength="1" [ngModelOptions]="{standalone: true}" type="text"
                                pattern="[0-9]*" inputmode="numeric" class="otp-box" [(ngModel)]="otp[3]"
                                (keyup)="onDigitInput($event, 3)" (input)="onOtpChange(3, $event)"
                                (paste)="$event.preventDefault()" autocomplete="one-time-code" #digit3 />
                              <input id="otp-input-4" maxlength="1" [ngModelOptions]="{standalone: true}" type="text"
                                pattern="[0-9]*" inputmode="numeric" class="otp-box" [(ngModel)]="otp[4]"
                                (keyup)="onDigitInput($event, 4)" (input)="onOtpChange(4, $event)"
                                (paste)="$event.preventDefault()" autocomplete="one-time-code" #digit4 />
                              <input id="otp-input-5" maxlength="1" [ngModelOptions]="{standalone: true}" type="text"
                                pattern="[0-9]*" inputmode="numeric" class="otp-box" [(ngModel)]="otp[5]"
                                (keyup)="onDigitInput($event, 5)" (input)="onOtpChange(5, $event)"
                                (paste)="$event.preventDefault()" autocomplete="one-time-code" #digit5 />
                            </div>
                            <div class="text-end mt-10">
                              <span *ngIf="!canResendOtp" class="fs-12">Resend code after : {{ otpTimer }}</span>
                              <a *ngIf="canResendOtp" class="resend-otp-link  h_b_ul txt-regular fs-14"
                                (click)="resendOtp()">Resend OTP</a>
                              <!-- <span *ngIf="canResendOtp" class="fs-14 txt-regular"> or </span>
                              <a *ngIf="canResendOtp" class="clr-cc-vilot h_b_ul  txt-regular fs-14" role="button"
                                (click)="sendSmsOtp()"> send
                                code via SMS</a> -->
                              <div *ngIf="otpError" class="otp-error">{{ otpError }}</div>
                            </div>
                            <div class="row mt-10">
                              <div class="col-lg-12">
                                <div class="d-flex">
                                  <div>
                                    <input id="remember_mfa" aria-labelledby="remember_mfa_label" type="checkbox"
                                      aria-labelledby="remember_mfa_label" type="checkbox"
                                      formControlName="remember_until" class="form-check-input" />
                                  </div>
                                  <div>
                                    <label for="remember_mfa" id="remember_mfa_label" class="ml-5 txt-regular m-0 mt-4">
                                      Remember MFA for 30 days
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- <div *ngIf="!isSmsOtpSent && !canResendOtp" class="divider-text mt-10 text-center fs-14">
                              <a class="clr-cc-vilot" role="button" (click)="sendSmsOtp()">or send code via SMS</a>
                            </div> -->
                            <!-- <div *ngIf="otpError" class="otp-error">{{ otpError }}</div> -->
                            <div class="mt-25">
                              <button type="submit" aria-label="Login" (click)="submitOtp('mfa')"
                                class="btn w-100 cc_p_btn fs_13">
                                Login
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                      }@else {
                      <div *ngIf="emailVerified" class="mt-10">
                        <div class="mt-10">
                          <p class="mt-30 txt-regular fs-16">Verify your email</p>
                          <p class="mt-16 txt-regular fs-14">
                            Enter the 6-digit code sent to <span class="text-regular-bold">{{userEmail}}</span> to
                            complete creating your
                            ClassCover account. This code expires
                            in <span class="text-regular-bold">{{expiryTime}} minutes</span>.</p>
                          <div class="mt-16">
                            <form>
                              <div class="d-flex justify-content-between gap-2 flex-wrap">
                                <input id="otp-input-0" maxlength="1" [ngModelOptions]="{standalone: true}" type="text"
                                  pattern="[0-9]*" inputmode="numeric" class="otp-box" [(ngModel)]="otp[0]"
                                  (keyup)="onDigitInput($event, 0)" (input)="onOtpChange(0, $event)"
                                  (paste)="$event.preventDefault()" autocomplete="one-time-code" #digit0 />
                                <input id="otp-input-1" maxlength="1" [ngModelOptions]="{standalone: true}" type="text"
                                  pattern="[0-9]*" inputmode="numeric" class="otp-box" [(ngModel)]="otp[1]"
                                  (keyup)="onDigitInput($event, 1)" (input)="onOtpChange(1, $event)"
                                  (paste)="$event.preventDefault()" autocomplete="one-time-code" #digit1 />
                                <input id="otp-input-2" maxlength="1" [ngModelOptions]="{standalone: true}" type="text"
                                  pattern="[0-9]*" inputmode="numeric" class="otp-box" [(ngModel)]="otp[2]"
                                  (keyup)="onDigitInput($event, 2)" (input)="onOtpChange(2, $event)"
                                  (paste)="$event.preventDefault()" autocomplete="one-time-code" #digit2 />
                                <input id="otp-input-3" maxlength="1" [ngModelOptions]="{standalone: true}" type="text"
                                  pattern="[0-9]*" inputmode="numeric" class="otp-box" [(ngModel)]="otp[3]"
                                  (keyup)="onDigitInput($event, 3)" (input)="onOtpChange(3, $event)"
                                  (paste)="$event.preventDefault()" autocomplete="one-time-code" #digit3 />
                                <input id="otp-input-4" maxlength="1" [ngModelOptions]="{standalone: true}" type="text"
                                  pattern="[0-9]*" inputmode="numeric" class="otp-box" [(ngModel)]="otp[4]"
                                  (keyup)="onDigitInput($event, 4)" (input)="onOtpChange(4, $event)"
                                  (paste)="$event.preventDefault()" autocomplete="one-time-code" #digit4 />
                                <input id="otp-input-5" maxlength="1" [ngModelOptions]="{standalone: true}" type="text"
                                  pattern="[0-9]*" inputmode="numeric" class="otp-box" [(ngModel)]="otp[5]"
                                  (keyup)="onDigitInput($event, 5)" (input)="onOtpChange(5, $event)"
                                  (paste)="$event.preventDefault()" autocomplete="one-time-code" #digit5 />
                              </div>
                              <div class="text-end mt-10">
                                <span *ngIf="!canResendOtp" class="fs-12">Resend code after : {{ otpTimer }}</span>
                                <a *ngIf="canResendOtp" class="resend-otp-link  h_b_ul txt-regular fs-14"
                                  (click)="resendEmailOtp()">Resend OTP</a>
                                <div *ngIf="otpError" class="otp-error">{{ otpError }}</div>
                              </div>
                              <div *ngIf="otpError" class="otp-error fs-14">{{ otpError }}</div>
                              <div class="mt-25">
                                <button [disabled]="!verifyBtnDisable" type="submit" aria-label="Login"
                                  (click)="submitOtp('email')" class="btn w-100 cc_p_btn fs_13 mt-20">
                                  Verify
                                </button>
                              </div>

                            </form>
                          </div>
                        </div>
                      </div>
                      }
                      <div class="mt-20" *ngIf="showOtpInput || emailVerified">
                        <div class="d-flex justify-content-center gap-5 flex-wrap">
                          <div class="mb-2 mb-md-0">
                            <a target="_blank" href="https://mail.google.com" class="txt-regular">
                              <img alt="" class="mail_logo" src="assets/images/side-nav/gmailLogo.svg" />
                              Open Gmail
                            </a>
                          </div>
                          <div>
                            <a target="_blank" href="https://outlook.live.com" class="txt-regular">
                              <img alt="" class="mail_logo" src="assets/images/side-nav/outlookLogo.svg" />
                              Open Outlook
                            </a>
                          </div>
                        </div>
                        <p class="txt-regular mt-20 text-center">
                          Can’t find your code? Check your spam folder!
                        </p>

                      </div>

                      <!-- <hr class="mt-25" /> -->

                    </form>
                  </div>
                  <!-- <div>
                    <p class="mt-15 txt-regular fs-14 grey-2 c-p text-center">
                      Login with your Queensland Department of Education credentials.
                      <a role="button" aria-label="Click here to register" href="/login-sso"
                        class="text-regular-medium fs-14 clr-cc-vilot c-p" appFocus appClick>Login</a>
                    </p>
                  </div>
                  <div class="col-lg-12 mt-5 text-center">
                    <p class="text-regular-medium">or</p>
                  </div> -->
                  <p class="clr-grey-3 txt-regular fs-16  c-p mt-20 text-center">
                    Looking for work?
                    <a role="button" aria-label="Create a profile" href="/signup"
                      class="text-regular-medium clr-cc-vilot fs-16   u_l c-p" appFocus appClick>
                      Create a profile</a>
                  </p>
                </div>
                <div *ngIf="!showOtpInput" class="col-lg-12 mt-20 text-center">
                  <p class="clr-grey-3 txt-regular fs-16 c-p">
                    Looking to hire or book?<a role="button" aria-label="Looking to hire click to  Get started"
                      href="https://www.classcover.com.au/lets-make-sure-you-are-in-the-right-place/"
                      class="text-regular-medium fs-16   u_l clr-cc-vilot c-p" appFocus appClick>
                      Get started</a>
                  </p>
                </div>
                <div class="col-lg-12 mt-5 text-center">
                  <p class="text-regular-medium">or</p>
                </div>
                <p class="mt-15 txt-regular  fs-16 clr-grey-3 c-p  text-center">
                  New to ClassCover?
                  <a role="button" aria-label="Click here to register" href="/register"
                    class="text-regular-medium fs-16 clr-cc-vilot c-p u_l" appFocus appClick>Click here to register</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}@if(isJobLoginDesign) {
<div class="container login-container">
  <!-- Job-specific login form elements go here -->
  <div class="container">
    <div class="row align-items-center flex-res r-form">
      <div class="offset-md-1 col-md-5 p-0 rounded-0 border-0 login_background_image">
        <div class="d-flex align-items-center justify-content-center position-relative">
          <img alt="" class="img-fluid w-100" src="../../../../assets/images/login/login_img.png" />
          <div class="position-absolute w-100 card-text-white">
            <div class="card-body login-content">
              <p class="join_hub">
                <span class="hub">The ultimate hub</span> for jobs and bookings in
                education
              </p>
              <div class="d-flex mt-20">
                <p class="txt-regular class-txt">New to ClassCover?</p>
                <a class="txt-regular ml-10 clr-cc-vilot"
                  href="https://www.classcover.com.au/lets-make-sure-you-are-in-the-right-place/">
                  Get started
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="">
          <div class="register-form">
            <div class="px-0 pt-5 mb-4">
              <p class="text-center">
                <img alt="" class="r_image" src="assets/images/side-nav/cc_original@2x.png" />
              </p>
              <p class="text-center mt-10">Login to ClassCover</p>
              <div class="col-lg-12 mt-20 text-center">
                <div class="">
                  <form [formGroup]="loginForm" novalidate class="text-center">
                    @if(!showOtpInput) {
                    <div class="form-floating left-labeled">
                      <label for="username" id="username_label">Username</label>
                      <input type="text" id="username" aria-labelledby="username_label" ariaLabel="enter user name"
                        id="userName" class="form-control input-sm mt-20 chat-input" formControlName="username" />
                    </div>
                    <br />
                    <div class="form-floating left-labeled">
                      <label for="userPassword" id="password_label">Password</label>
                      <input type="password" id="userPassword" aria-labelledby="password_label"
                        ariaLabel="enter password" class="form-control input-sm chat-input"
                        formControlName="password" />
                    </div>
                    <br />
                    <div class="mt-5">
                      <button type="submit" (click)="logIn()" aria-label="Login" class="btn w-100 cc_p_btn fs_13">
                        Login
                      </button>

                    </div>
                    <div class="mt-10 d-flex justify-content-end">
                      <a href="/forgot-password" role="button" aria-label="Forget Password?"
                        class="text-regular-medium align-right clr-cc-vilot c-p" appFocus appClick>
                        Forgot Password</a>
                    </div>
                    <hr class="mt-25" />
                    @if (mandatoryMessage) {
                    <div class="warningMessage text-center text-danger mt-2">
                      <p aria-label="Please Enter User Name and Password">
                        Please Enter User Name and Password.
                      </p>
                    </div>
                    } @if (validationMessage) {
                    <div class="warningMessage text-center text-danger mt-2">
                      <p aria-label="Invalid User Name or Password">
                        {{ error_log }}
                      </p>
                    </div>
                    }
                    }
                    @if(showOtpInput) {
                    <div *ngIf="showOtpInput" class="mt-10">
                      <p class="mt-30 txt-regular fs-16">Check your email for a code</p>
                      <p class="mt-16 txt-regular fs-14">We've sent a 6-digit code to {{userEmail}}. This code expires
                        in {{expiryTime}} minutes.</p>
                      <div class="mt-16">
                        <form>
                          <div class="d-flex justify-content-between gap-2 flex-wrap">
                            <input id="otp-input-0" maxlength="1" [ngModelOptions]="{standalone: true}" type="text"
                              pattern="[0-9]*" inputmode="numeric" class="otp-box" [(ngModel)]="otp[0]"
                              (keyup)="onDigitInput($event, 0)" (input)="onOtpChange(0, $event)"
                              (paste)="$event.preventDefault()" autocomplete="one-time-code" #digit0 />
                            <input id="otp-input-1" maxlength="1" [ngModelOptions]="{standalone: true}" type="text"
                              pattern="[0-9]*" inputmode="numeric" class="otp-box" [(ngModel)]="otp[1]"
                              (keyup)="onDigitInput($event, 1)" (input)="onOtpChange(1, $event)"
                              (paste)="$event.preventDefault()" autocomplete="one-time-code" #digit1 />
                            <input id="otp-input-2" maxlength="1" [ngModelOptions]="{standalone: true}" type="text"
                              pattern="[0-9]*" inputmode="numeric" class="otp-box" [(ngModel)]="otp[2]"
                              (keyup)="onDigitInput($event, 2)" (input)="onOtpChange(2, $event)"
                              (paste)="$event.preventDefault()" autocomplete="one-time-code" #digit2 />
                            <input id="otp-input-3" maxlength="1" [ngModelOptions]="{standalone: true}" type="text"
                              pattern="[0-9]*" inputmode="numeric" class="otp-box" [(ngModel)]="otp[3]"
                              (keyup)="onDigitInput($event, 3)" (input)="onOtpChange(3, $event)"
                              (paste)="$event.preventDefault()" autocomplete="one-time-code" #digit3 />
                            <input id="otp-input-4" maxlength="1" [ngModelOptions]="{standalone: true}" type="text"
                              pattern="[0-9]*" inputmode="numeric" class="otp-box" [(ngModel)]="otp[4]"
                              (keyup)="onDigitInput($event, 4)" (input)="onOtpChange(4, $event)"
                              (paste)="$event.preventDefault()" autocomplete="one-time-code" #digit4 />
                            <input id="otp-input-5" maxlength="1" [ngModelOptions]="{standalone: true}" type="text"
                              pattern="[0-9]*" inputmode="numeric" class="otp-box" [(ngModel)]="otp[5]"
                              (keyup)="onDigitInput($event, 5)" (input)="onOtpChange(5, $event)"
                              (paste)="$event.preventDefault()" autocomplete="one-time-code" #digit5 />
                          </div>
                          <div class="text-end mt-10">
                            <span *ngIf="!canResendOtp" class="fs-12">Resend code after {{ otpTimer }}</span>
                            <a *ngIf="canResendOtp" class="resend-otp-link" (click)="resendOtp()">Resend OTP</a>
                          </div>
                          <div *ngIf="!isSmsOtpSent && !canResendOtp" class="divider-text mt-10 text-center fs-14">
                            <a class="clr-cc-vilot" role="button" (click)="sendSmsOtp()">or send code via SMS</a>
                          </div>
                          <div *ngIf="otpError" class="otp-error">{{ otpError }}</div>
                          <div class="mt-25">
                            <button type="submit" aria-label="Login" (click)="submitOtp('mfa')"
                              class="btn w-100 cc_p_btn fs_13">
                              Login
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="mt-20">
                      <div class="d-flex justify-content-center gap-5 flex-wrap">
                        <div class="mb-2 mb-md-0">
                          <a target="_blank" href="https://mail.google.com" class="txt-regular">
                            <img alt="" class="mail_logo" src="assets/images/side-nav/gmailLogo.svg" />
                            Open Gmail
                          </a>
                        </div>
                        <div>
                          <a target="_blank" href="https://outlook.live.com" class="txt-regular">
                            <img alt="" class="mail_logo" src="assets/images/side-nav/outlookLogo.svg" />
                            Open Outlook
                          </a>
                        </div>
                      </div>
                    </div>
                    <p class="txt-regular mt-20 text-center">
                      Can’t find your code? Check your spam folder!
                    </p>

                    }
                  </form>
                </div>
                <p class="mt-15 txt-regular clr-grey-3 c-p">
                  New to ClassCover?
                  <a role="button" aria-label="Click here to register" href="/register"
                    class="text-regular-medium clr-cc-vilot c-p" appFocus appClick>Click here to register</a>
                </p>
                <div class="col-lg-12 mt-5 text-center">
                  <p class="text-regular-medium">or</p>
                </div>
                <p class="txt-regular clr-grey-3 c-p mt-20">
                  Looking for work?
                  <a role="button" aria-label="Create a profile" href="/signup"
                    class="text-regular-medium clr-cc-vilot c-p" appFocus appClick>
                    Create a profile</a>
                </p>
              </div>
              <div class="col-lg-12 mt-20 text-center">
                <p class="txt-regular clr-grey-3 c-p">
                  Looking to hire<a role="button" aria-label="Looking to hire click to  Get started"
                    href="https://www.classcover.com.au/lets-make-sure-you-are-in-the-right-place/"
                    class="text-regular-medium clr-cc-vilot c-p" appFocus appClick>
                    Get started</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}
}